// @flow
import InviteUserToOfficeModalContainer from './InviteUserToOfficeModalContainer'
export default InviteUserToOfficeModalContainer
